<template>
  <div :class="{ rtl: $i18n.locale == I18nLocaleEnum.AR }">
    <!-- Header -->
    <div>
      <slot name="header"></slot>
    </div>
    <!-- Main -->
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts">
import { I18nLocaleEnum } from "./../enums/locale.enum";
import { StorageKeys } from "./../enums/storageKeys.enum";

export default {
  data() {
    return {
      I18nLocaleEnum,
    };
  },
  components: {},
  beforeMount() {
    let storedLocale = localStorage.getItem(StorageKeys.lang);
    if (storedLocale) (this as any).$i18n.locale = storedLocale;
  },
  props: ["headline"],
};
</script>
